export default __webpack_public_path__ + "static/media/Front-Villa-Dbouk.591c374f.jpg";